<template>
  <SV title="Tools.工具箱" class="tool">
      <LAlert type="info">好像暂时没有工具呢...</LAlert>
  </SV>
</template>

<script>
import LAlert from './../components/LAlert';
import SV from './../components/StandardView'

export default {
  name: "Tools",
  components:{
      LAlert,
      SV
  }
};
</script>

<style>
.tool {
  
}
.tool h1 {
  position: relative;
  color: #dc9495;
  letter-spacing: 2px;
  line-height: 1.7rem;
}
</style>